import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_phdassets.png",
      alt: "Estratégias PhDAssets",
    },
    title: "PhDAssets IAs Carteiras",

    // String ou array de strings
    text: [
      "As IAS PhDAssets fazem previsões de cada ativo para 15 dias ou mais dias, para o dia de negociação antes da abertura e a cada 30 minutos durante o pregão da B3. Estas previsões são combinadas, sendo que a de melhor retorno esperado e a escolhida pelas IAs para estarem na carteira do cliente. A carteira comprada do cliente está limitada a 5 ativos. Cada ativo possui um stop loss e um stop gain determinado pelas IAS.",
    ],
    testimonial: {
      text: "PhDAssets IAs gerenciado sua carteira de investimento",
      author: {
        name: "PhDAssets Ltda",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias PhDAssets IAs",
    heading: "Escolha a sua carteira de investimento",
    subtitle: "Escolha uma das carteiras para investir I) Carteira comprada, II) vendida ou III) vendida/comprada",
  },

  cta: {
    title: "PhDAssets Carteiras",
    subtitle: "Escolha a sua Carteira",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A PhDAssets",
    col1: [
      "A empresa PhDRisk Ltda é especializada na construção de IAs para o mercado de risco de crédito e financeiro. Fundada em 2009 foi reconhecida em 2010 pelo Ministério da Ciência e Tecnologia como empresa inovadora, em 2017 foi escolhida entre as melhores fintechs do Brasil pela Febraban. Desenvolveu sistema de risco de crédito para o Bradesco Cartões. Ainda participou do primeiro LIFT-Laboratório Informações Financeiras e Tecnológicas da Fenasbac e Banco Central. Atualmente está concentrada no desenvolvimento de IAS para o mercado de ações. Seus principais produtos são: PhDAssets IAS disponível como aplicativo de celular nas lojas Android e Apple; e PhDAssets MT5 as IAs usam o Metatrader 5 para negociar e administrar carteiras dos clientes das corretoras. ",
    ],
    col2: [
      // "Nosso compromisso com a qualidade é inegociável. Cada robô trader desenvolvido pela SigmaSix passa por rigorosos testes e análises para garantir seu desempenho e eficácia. Nosso objetivo é oferecer soluções que não apenas atendam, mas excedam as expectativas de nossos clientes.",
      // "Além disso, reconhecemos que cada investidor é único, com suas próprias necessidades e objetivos. Por isso, oferecemos soluções personalizadas e adaptadas às preferências e metas individuais de cada cliente. Nosso foco é sempre fornecer resultados tangíveis que ajudem nossos clientes a alcançar seus objetivos financeiros. ",
      // "A SigmaSix é mais do que uma empresa de tecnologia financeira. Somos uma comunidade de investidores, inovadores e visionários, unidos por uma paixão compartilhada pelo sucesso financeiro. Estamos comprometidos em construir um futuro onde todos tenham acesso a ferramentas e recursos que os capacitem a alcançar a liberdade financeira. Junte-se a nós e descubra o que a SigmaSix pode fazer por você.",
    ],
  },

  stats: {
    title: "Retornos Esperados das Carteiras",
    subtitle: "Carteira Comprada",
    data: [
      {
        value: "33,08%",
        description: "em 2021",
      },
      {
        value: "33,80%",
        description: "em 2022",
      },
      {
        value: "34,00%",
        description: "em 2023",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da PhDAssets?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs",
    data: [
      {
        icon: iconsSet.chip,
        // title: "Adaptação Dinâmica ao Mercado",
        description: "Mais do que robôs, são inteligências artificiais que aprendem com seus erros",
      },
      {
        icon: iconsSet.balance,
        // title: "Decisões Baseadas em Dados Volumosos",
        description:
          "Mais do que simples estratégias. Analisam todas as estratégias e aprendem qual a dominante no momento",
      },
      {
        icon: iconsSet.paper_board,
        // title: "Minimização de Riscos",
        description:
          "Mais do simples decisões baseadas no passado, as inteligências olham para o futuro fazendo previsões e apreendendo continuamente a cada 30 minutos",
      },
      {
        icon: iconsSet.monitoring,
        // title: "Maximização de Retornos",
        description: "Convidamos você investidor no futuro. As IAs-Inteligências Artificiais são o futuro",
      },
      {
        icon: iconsSet.test_tube,
        // title: "Operações 24/7",
        description:
          "A tecnologia PhDAssets é baseada em ciência e seu cientista chefe acompanhas inovações cientificas das IAs",
      },
      {
        icon: iconsSet.graduation_cap,
        // title: "Customização e Especialização",
        description: "O cientista chefe é professor em renomadas universidades da Itália, França, Portugal e EUA",
      },
      // ...defaultContent.features.data,
    ],
  },

  // testimonials: [
  //   {
  //     text: "Colaborei com Tekton e Roberto para desenvolver uma ferramenta de otimização de portfólio melhor para a Rational Investment Methodology (uma empresa de assessoria de investimentos registradas nos EUA, que gerencia portfólios de ações específicos - e altamente complexos - para seus clientes). Suas habilidades de programação e análise são incomparáveis. Acredito que você não ficaria decepcionado ao trabalhar com a Tekton.",
  //     author: "Danilo Santiago",
  //     job: "Investment Advisor (Rational Investment Methodology, New York, USA)",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Tive o prazer de trabalhar com Tekton e Roberto na construção de modelos estruturados para implantação com meus clientes. As habilidades técnicas de Roberto foram fundamentais para nós desenvolvermos uma aplicação altamente pragmática e funcional que ajudou a otimizar a carga de trabalho da minha empresa e a entregar melhores resultados de investimento para clientes exigentes. A Tekton esteve altamente engajada em resolver nossos problemas com ferramentas superiores de modelagem e negociação automatizadas.",
  //     author: "Brett Janis",
  //     job: "Investment Advisor (Strong Bridge Advisers, San Francisco, USA)",
  //     // image_url:
  //     //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
